<mat-toolbar color="secondary">
    <img class="nav-logo" 
        alt="Orcwood YAK Logo"
        src="assets/images/favicon/android-chrome-192x192.png"/>
    <span class="ml-2">
        YAK
    </span>
</mat-toolbar>
